import { render } from "./ContatoList.vue?vue&type=template&id=6822df18"
import script from "./ContatoList.vue?vue&type=script&lang=js"
export * from "./ContatoList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__